<template>
	<div v-if="!code || code <= 0" class="w5-error-page">
		<img :src="stylePathToLogo || '/static/img/logo/logo.png'" />
		<br><br>
		<div class="alert alert-danger" role="alert"><p v-withSafeTags="localeFtc(message)"></p></div>
	</div>
	<notFoundPage v-else-if="code === 404" />
	<error503 v-else :response="Response" />
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import notFoundPage from '@/components/notFound'
import error503 from '@/components/crud/error503'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'errorPage',
	//=========================================================================
	props: ['message', 'code'],
	//=========================================================================
	data() {
		return {
			'Response': false
		}
	},
	//=========================================================================
	created() {
		if (this.code && this.code > 0)
			this.Response = {
				'status': this.code
			}
	},
	//=========================================================================
	components: {
		notFoundPage,
		error503
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.w5-error-page {
	position: fixed;
	top: 20%;
	left: 25%;	
	text-align: center;
	width: 50%;	
}

@media (max-width: 767px) {
	.w5-error-page {
		left: 5%;
		width: 90%;
	}
}
</style>



// WEBPACK FOOTER //
// errorPage.vue?117185ae